module.exports = __webpack_public_path__ + "img/open_in_new_gray_24px.83d1d462.png";